module.exports = __webpack_public_path__ + "static/media/view_claims_1.25a99f3e.png";